import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { CodeTypeValue } from '../../custumcomponents/codetypes/codetypevalue.interface';


@Pipe({
  name: 'CodeTypeValueFilter'
})

@Injectable()
export class CodeTypeValuePipe implements PipeTransform {

  transform(value: CodeTypeValue[], filter: string): CodeTypeValue[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CodeTypeValue) =>
      app.LongValue != null && app.LongValue.toLocaleLowerCase().indexOf(filter) != -1

      || app.ShortValue != null && app.ShortValue.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}
